module.exports = __webpack_public_path__ + "static/media/3件套@2x.7d63c91a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/3件套@2x.png
// module id = 1519
// module chunks = 0